import d00 from '../assets/team/d00.png';
import d01 from '../assets/team/d01.png';
import d02 from '../assets/team/d02.png';
import d03 from '../assets/team/d03.png';
import d04 from '../assets/team/d04.png';
import d05 from '../assets/team/d05.png';
import d06 from '../assets/team/d06.png';
import d07 from '../assets/team/d07.png';
import d08 from '../assets/team/d08.png';
import d09 from '../assets/team/d09.png';
import d10 from '../assets/team/d10.png';
import d11 from '../assets/team/d11.png';
import d12 from '../assets/team/d12.png';



export const DIR_CARD_IMAGES = [
  d00,     
  d01,
  d02,
  d03,
  d04,
  d05,
  d06,
  d07,
  d08,
  d09,
  d10,
  d11,
  // null,
  d12,
];
